import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { PropType, ref } from "vue";
import { ContentOverviewApi } from "@/services/Api";
import { IPagination } from "@/models/IPagination";
import { IContentOverviewFilter } from "@/models/IContentOverviewFilter";
import { IContentOverviewTile } from "@/models/IContentOverviewTile";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentOverviewPageWrapper',
  props: {
  id: {
    type: Number,
    required: true,
  },
  subject: {
    type: Number,
    required: true,
  },
  type: {
    type: Number,
    required: true,
  },
  pagination: {
    type: Object as PropType<IPagination>,
    required: true,
  },
  typeFiltersToShow: {
    type: Array as PropType<Array<IContentOverviewFilter>>,
    required: true,
  },
  mainHeader: {
    type: String,
    required: true,
  },
  subHeader: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const hideInitial = ref<boolean>(false);
const activeFilterSubjectId = ref<number>(props.subject);
const activeFilterTypeId = ref<number>(props.type);
const currentPage = ref<number>(1);
const pagination = ref<IPagination>(props.pagination);
const contents = ref<IContentOverviewTile[]>([]);
const showFilterLevel = ref<number>(props.subject == 0 ? 0 : 1);
const mainHeader = ref<string>(props.mainHeader);
const subHeader = ref<string>(props.subHeader);
const description = ref<string>(props.description);
const typeFiltersToShow = ref<Array<IContentOverviewFilter>>(props.typeFiltersToShow);
const hasLoaded = ref<boolean>(false);

const onSubjectFilterClick = async (id: number) => {
  activeFilterSubjectId.value = id;
  await getContentClean();
  hideInitial.value = true;
  showFilterLevel.value = 1;
  setUrl();
};

const resetFilters = async () => {
  activeFilterSubjectId.value = 0;
  activeFilterTypeId.value = 0;
  await getContentClean();
  hideInitial.value = true;
  showFilterLevel.value = 0;
  setUrl();
};

const onTypeFilterClick = async (id: number) => {
  activeFilterTypeId.value = id;
  await getContentClean();
  hideInitial.value = true;
  setUrl();
};

const getContent = async () => {
  const contentRes = await ContentOverviewApi.getByFilter(
    props.id,
    activeFilterSubjectId.value,
    activeFilterTypeId.value,
    currentPage.value
  );
  contents.value = [...contents.value, ...contentRes?.tiles.sort(_sortContent).reverse()];
  pagination.value = contentRes.pagination;
};

const getContentClean = async () => {
  const contentRes = await ContentOverviewApi.getByFilter(
    props.id,
    activeFilterSubjectId.value,
    activeFilterTypeId.value,
    1
  );
  contents.value = [];
  currentPage.value = 1;
  contents.value = [...contents.value, ...contentRes?.tiles.sort(_sortContent).reverse()];
  pagination.value = contentRes.pagination;
  typeFiltersToShow.value = contentRes.typeFilters;
  mainHeader.value = contentRes.headline;
  description.value = contentRes.description;
};

const setUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.set("subject", activeFilterSubjectId.value.toString());
  url.searchParams.set("type", activeFilterTypeId.value.toString());
  window.history.pushState({}, "", url.toString());
};

const onPaginationClick = async () => {
  currentPage.value++;
  await getContent();
};

const onMoveToTopClick = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const _sortContent = (x: IContentOverviewTile, y: IContentOverviewTile) => {
  const date1 = new Date(x.date);
  const date2 = new Date(y.date);

  return date1.getTime() - date2.getTime();
};

const onMounted = () => {
  hasLoaded.value = true;
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    activeFilterSubjectId: activeFilterSubjectId.value,
    activeFilterTypeId: activeFilterTypeId.value,
    contents: contents.value,
    currentPage: currentPage.value,
    hideInitial: hideInitial.value,
    onSubjectFilterClick: onSubjectFilterClick,
    onMoveToTopClick: onMoveToTopClick,
    onPaginationClick: onPaginationClick,
    onTypeFilterClick: onTypeFilterClick,
    showFilterLevel: showFilterLevel.value,
    typeFiltersToShow: typeFiltersToShow.value,
    pagination: pagination.value,
    mainHeader: mainHeader.value,
    subHeader: subHeader.value,
    description: description.value,
    hasLoaded: hasLoaded.value,
    resetFilters: resetFilters
  })
}
}

})